
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.25 22.5A2.253 2.253 0 010 20.25v-6A5.256 5.256 0 015.25 9H7.5c.827 0 1.5.672 1.5 1.5V15h6.242l1.079-2.697-4.557-1.177a2.237 2.237 0 01-1.375-1.036 2.238 2.238 0 01-.241-1.705l1.688-6.533-1.453-.375a.746.746 0 01-.538-.914.749.749 0 01.914-.538l2.178.563a.748.748 0 01.539.913l-.375 1.453 8.715 2.25a2.252 2.252 0 011.616 2.74l-1.276 4.945.272 2.217A2.246 2.246 0 0124 17.25V18a.75.75 0 01-1.5 0v-.75a.75.75 0 00-.75-.75H8.25a.75.75 0 01-.75-.75V15h-6v5.25c0 .413.336.75.75.75H3a.75.75 0 010 1.5h-.75zM20.902 15l-.192-1.563-2.925-.756L20.902 15zM7.5 13.5v-3H5.25c-1.781 0-3.32 1.288-3.672 3H7.5zm4.101-4.741a.746.746 0 00.539.914l8.715 2.251 1.125-4.357a.751.751 0 00-.539-.913l-8.714-2.249-1.126 4.354z"}}),_c('path',{attrs:{"d":"M7.5 24c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5a1.501 1.501 0 000 3c.827 0 1.5-.673 1.5-1.5s-.673-1.5-1.5-1.5zM19.5 24c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5S21 21.827 21 21s-.673-1.5-1.5-1.5zM12 22.5a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM14.798 9a.75.75 0 01-.726-.937l.404-1.564a.75.75 0 111.453.375l-.404 1.564a.753.753 0 01-.727.562zM18.642 10.125a.75.75 0 01-.726-.937l.404-1.564a.75.75 0 111.451.375l-.404 1.564a.749.749 0 01-.725.562z"}})])
          )
        }
      }
    